import fetch from "auth/FetchInterceptor";

const ConstantsService = {};

const api = "constants";

ConstantsService.get = function (params) {
  return fetch({
    url: `${api}`,
    method: "GET",
    params,
  });
};

export default ConstantsService;
